<template>
  <div class="container mx-auto flex min-h-screen flex-col items-center justify-center text-center">
    <h1 class="text-5xl font-semibold">404</h1>
    <h2 class="mt-4">Page not found!</h2>
  </div>
</template>
